import { createContext, useContext, useState } from "react";
import formacoesjson from 'Common/json/listaFormacao.json'
import { DiCss3, DiHtml5, DiReact } from "react-icons/di";
import { SiJavascript } from "react-icons/si";
import { MdWeb } from 'react-icons/md'
 
export const FormacaoContext = createContext()
FormacaoContext.displayName = "Formação"

export function FormacaoProvider({ children }) {

    const [escolha, setEscolha] = useState()

    const [listaFormacoes, setListaFormacoes] = useState(formacoesjson)

    var modo = true;

    const [formacao, setFormacao] = useState({
        nome: "Formação misteriosa",
        apresentacao: "Clique para ver as minhas formações",
        icone: "",
        link: "",
        ativo: false
    })

    const icones = {
        css: <DiCss3 size={100} color={"#3492cb"} />,
        js: <SiJavascript size={80} color="#ead41c" />,
        react: <DiReact size={100} color="#4ad5ff" />,
        html: <DiHtml5 size={100} color="#d84924" />,
        programacao: <MdWeb size={100} color="#00c04b"/>
    }

    return (
        <FormacaoContext.Provider
            value={{
                escolha,
                setEscolha,
                formacao,
                setFormacao,
                modo,
                formacoesjson,
                icones,
                listaFormacoes,
                setListaFormacoes
            }}
        >
            {children}
        </FormacaoContext.Provider>

    )
}


export function useFormacao() {
    const { escolha, setEscolha, formacao, setFormacao, modo, formacoesjson, icones, listaFormacoes,
        setListaFormacoes } = useContext(FormacaoContext)

    function mudaFormacaoEscolhida(formacao) {
        setEscolha(formacao.formacao)
        return (
            setFormacao({
                nome: formacao.formacao,
                apresentacao: formacao.apresentacao,
                icone: formacao.icone,
                link: formacao.link,
                ativo: true
            })
        )
    }

    function resetFormacaoEscolhida() {
        setFormacao({
            nome: "Formação misteriosa",
            apresentacao: "Clique para ver as minhas formações",
            icone: "",
            link: "",
            ativo: false
        })
    }


    function iconeClicado(formacao) {

        mudaFormacaoEscolhida(formacao)

        setListaFormacoes([...listaFormacoes, listaFormacoes.filter(listaItem => {
            if (listaItem === formacao) {
                return listaItem.ativo = true
            }
            listaItem.ativo = false
        })])
    }

    return {
        escolha,
        formacao,
        mudaFormacaoEscolhida,
        resetFormacaoEscolhida,
        modo,
        formacoesjson,
        icones,
        iconeClicado,
        listaFormacoes,
        setListaFormacoes

    }
}
